import React from 'react';
import { Alert, Form, Spinner } from 'react-bootstrap';

/**
 * Same visual language as the corporate Credentials Vault gate (Alert + gate primary button).
 * Render inside <CredentialVaultGateShell /> for layout parity with corporate unlock.
 */
export default function PersonalVaultUnlockAlert({
  heading = 'Unlock personal vault',
  description,
  password,
  onPasswordChange,
  showPassword,
  onToggleShowPassword,
  error,
  busy,
  onSubmit,
  submitLabel = 'Unlock',
}) {
  return (
    <Alert variant="light" className="credential-vault-full-page-alert mb-0">
      <Alert.Heading className="h5 mb-3">{heading}</Alert.Heading>
      <Form onSubmit={onSubmit} autoComplete="off">
        {description}
        {error ? <div className="text-danger small mb-3">{error}</div> : null}
        <Form.Group className="mb-3">
          <Form.Label>Personal vault password</Form.Label>
          <div className="position-relative password-input-wrapper">
            <Form.Control
              autoFocus
              type={showPassword ? 'text' : 'password'}
              autoComplete="off"
              name="credentialVaultPersonalUnlockNonce"
              value={password}
              onChange={(ev) => onPasswordChange(ev.target.value)}
              disabled={busy}
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={onToggleShowPassword}
              disabled={busy}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden />
            </button>
          </div>
        </Form.Group>
        <div className="task-form-toolbar toolbar toolbar-bottom pt-2 credential-vault-personal-unlock-toolbar">
          <button type="submit" className="new-user-btn credential-vault-gate-primary-btn" disabled={busy}>
            {busy ? (
              <Spinner animation="border" size="sm" variant="light" className="me-2" />
            ) : submitLabel === 'Unlock' ? (
              <i className="fas fa-unlock me-2" aria-hidden />
            ) : null}
            {submitLabel}
          </button>
        </div>
      </Form>
    </Alert>
  );
}
